// extracted by mini-css-extract-plugin
export default {"Outer":"Icon_Outer__iFxC1","Inverted":"Icon_Inverted__SnLBy"};